export const CLOSE_ENRICHMENT_REQUEST = "CLOSE_ENRICHMENT_REQUEST"
export const GET_INTERNAL_ENRICHMENT_REQUESTS = "GET_INTERNAL_ENRICHMENT_REQUESTS"
export const RECEIVE_INTERNAL_ENRICHMENT_REQUESTS = "RECEIVE_INTERNAL_ENRICHMENT_REQUESTS"
export const GET_IMPORTS_HISTORY = "GET_IMPORTS_HISTORY"
export const RECEIVE_IMPORTS_HISTORY = "RECEIVE_IMPORTS_HISTORY"
export const RECEIVE_CSV_MAPPING = "RECEIVE_CSV_MAPPING"
export const UPLOAD_CONSTITUENT_DATA = "UPLOAD_CONSTITUENT_DATA"
export const UPDATE_CSV_HEADERS = "UPDATE_CSV_HEADERS"
export const UPDATE_TOTAL_MEMBERS = "UPDATE_TOTAL_MEMBERS"
export const CREATE_SANDBOX = "CREATE_SANDBOX"
export const DELETE_ALL_CONSTITUENTS = "DELETE_ALL_CONSTITUENTS"

export const getInternalEnrichmentRequests = (success, error) => ({
  type: GET_INTERNAL_ENRICHMENT_REQUESTS,
  success,
  error,
})

export const createSandbox = (success, error) => ({
  type: CREATE_SANDBOX,
  success,
  error,
})

export const deleteAllConstituents = (success, error) => ({
  type: DELETE_ALL_CONSTITUENTS,
  success,
  error,
})

export const closeEnrichmentRequest = (params, success, error) => ({
  type: CLOSE_ENRICHMENT_REQUEST,
  params,
  success,
  error,
})

export const updateTotalMembers = (success, error) => ({
  type: UPDATE_TOTAL_MEMBERS,
  success,
  error,
})

export const receiveInternalEnrichmentRequests = (resp) => ({
  type: RECEIVE_INTERNAL_ENRICHMENT_REQUESTS,
  resp,
})

export const getImportsHistory = (success, error) => ({
  type: GET_IMPORTS_HISTORY,
  success,
  error,
})

export const receiveImportsHistory = (resp) => ({
  type: RECEIVE_IMPORTS_HISTORY,
  resp,
})

export const receiveCSVMapping = (resp) => ({
  type: RECEIVE_CSV_MAPPING,
  resp,
})

export const updateCSVHeaders = (headers) => ({
  type: UPDATE_CSV_HEADERS,
  headers,
})

export const uploadConstituentData = (params, success, error) => ({
  type: UPLOAD_CONSTITUENT_DATA,
  params,
  success,
  error,
})
